import React, { createContext, useContext, type ReactNode, useState } from "react"
import { Employee } from "../Objects/Employee/Employee"

interface EmployeeContextType {
  isOpen: boolean
  employee: Employee | undefined | null
  setEmployee: (employee: Employee | undefined | null) => void
  setTitle: (title: string) => void
  title: string
  handleCloseEmployee: () => void
  handleOpenEmployee: () => void
  setIsMaster: (isMaster: boolean) => void
  isCreateMaster: boolean
}

const EmployeeContext = createContext<EmployeeContextType | undefined>(undefined)

const useEmployee = (): EmployeeContextType => {
  const [isOpen, setOpen] = useState(false)

  const [employee, setEmployee] = useState<Employee | undefined | null>(undefined)

  const [title, setTitle] = useState("")

  const [isCreateMaster, setIsMaster] = useState(false)

  const handleCloseEmployee = () => {
    setOpen(false)
  }

  const handleOpenEmployee = () => {
    setOpen(true)
  }

  return {
    isOpen,
    employee,
    title,
    isCreateMaster,
    setTitle,
    setIsMaster,
    handleCloseEmployee,
    handleOpenEmployee,
    setEmployee,
  }
}

interface EmployeeProviderProps {
  children: ReactNode
}

export const MenuEmployeeProvider: React.FC<EmployeeProviderProps> = ({ children }) => {
  const employee = useEmployee()

  return <EmployeeContext.Provider value={employee}>{children}</EmployeeContext.Provider>
}

export const useEmployeeContext = (): EmployeeContextType => {
  const context = useContext(EmployeeContext)

  if (!context) {
    throw new Error("useEmployeeContext must be used within an EmployeeProvider")
  }

  return context
}
